import { GetJournalsFilterKey } from 'types';

export const journalFilterFields: Record<GetJournalsFilterKey, GetJournalsFilterKey> = {
    type: 'type',
    status: 'status',
    fromYear: 'fromYear',
    toYear: 'toYear',
};
